import gql from 'graphql-tag';

export default gql`
  mutation CreateAnalyticsEvent(
    $payload: Json,
    $subjectId: String,
    $subjectType: String,
    $title: String,
    $type: AnalyticsEventType!,
    $url: String,
    $value: Decimal,
  ) {
    createAnalyticsEvent(
      payload: $payload,
      subjectId: $subjectId,
      subjectType: $subjectType,
      title: $title,
      type: $type,
      url: $url,
      value: $value,
    ) {
      id
    }
  }
`;
